import React, {useState} from 'react';
import {FilterExteriorColorTranslation} from '../../typing/translations';
import {ColorFilterItem, FilterItem} from '../../typing/used-inventory';
import {FilterCheckColor} from '../filter-check-color';
import FilterContentLabel from '../filter-content-label';
import {
  StyledExteriorContainer,
  StyledFilterExteriorColorContainer,
} from './styles';

interface FilterExteriorColorProps {
  colors?: ColorFilterItem[];
  onHandleColorCheck: (item: FilterItem) => void;
  translation: FilterExteriorColorTranslation;
  isMobile: boolean;
}
const FilterExteriorColor: React.FC<FilterExteriorColorProps> = ({
  translation,
  colors,
  onHandleColorCheck,
  isMobile
}) => {
  const [hideOptions, setHideOptions] = useState(false);
  return (
    <StyledFilterExteriorColorContainer className="filter-exterior-color-container">
      <div className="label-wrapper">
        <FilterContentLabel
          label={translation.label}
          hideOptions={hideOptions}
          setHideOptions={setHideOptions}
          isMobile={isMobile}
        />
      </div>
      {(hideOptions && isMobile) || !isMobile ? (
        <StyledExteriorContainer className="check-colors-container">
          {colors?.map((color: ColorFilterItem) => (
            <FilterCheckColor
              label={color.value}
              value={color.value}
              onClick={onHandleColorCheck.bind(null, color)}
              checked={color.isChecked}
              isDisabled={
                typeof color.stock !== 'undefined' &&
                color?.stock <= 0 &&
                !color.isChecked
                  ? true
                  : false
              }
              color={color.colorHex}
            />
          ))}
        </StyledExteriorContainer>
      ) : null}
    </StyledFilterExteriorColorContainer>
  );
};

export default FilterExteriorColor;
